var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook332(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4046 20.9195C17.1816 20.9195 21.8648 16.2363 21.8648 10.4592C21.8648 4.68222 17.1816 -0.000976562 11.4046 -0.000976562C5.62754 -0.000976562 0.944336 4.68222 0.944336 10.4592C0.944336 16.2363 5.62754 20.9195 11.4046 20.9195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8038 3.20996H12.4866C11.1115 3.20996 9.58202 3.78831 9.58202 5.78158C9.58873 6.47611 9.58202 7.14126 9.58202 7.88985H7.99121V10.4213H9.63125V17.7089H12.6449V10.3732H14.634L14.814 7.88275H12.593C12.593 7.88275 12.5979 6.77489 12.593 6.45316C12.593 5.66547 13.4126 5.71057 13.4619 5.71057C13.8519 5.71057 14.6103 5.71171 14.805 5.71057V3.20996H14.8038Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9204,
    height: 20.9204,
    fill: "white",
    transform: "translate(0.944336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook332);
export default __webpack_public_path__ + "static/media/facebook-3-3 2.401c702d11bfc5a4c9398facaee6fdaf.svg";
export { ForwardRef as ReactComponent };